import Cookie from 'js-cookie';
import { getMainDomain } from './common';
import { ThemeConfig } from 'antd';

/**
 * Ant Design 全局主题
 */
export const theme: ThemeConfig = {
  token: {
    borderRadius: 8,
    colorPrimary: '#FB6600',
    colorLink: '#FB6600',
    colorPrimaryHover: '#e65500',
    colorPrimaryActive: '#e65500',
    colorPrimaryBg: '#FDF6F0',
    colorPrimaryBgHover: '#FDF6F0',
  },
  components: {
    Tooltip: {
      colorBgSpotlight: '#FFFFFF',
      colorTextLightSolid: '#1F1F1F',
    },
  },
};

export const setTheme = () => {
  const {
    colorPrimary,
    colorPrimaryHover,
    colorPrimaryActive,
    colorPrimaryBg,
    colorPrimaryBgHover,
  } = theme.token!;
  const vars = {
    '--primary-color': colorPrimary,
    '--primary-color-hover': colorPrimaryHover,
    '--primary-color-active': colorPrimaryActive,
    '--primary-bg-color': colorPrimaryBg,
    '--primary-bg-color-hover': colorPrimaryBgHover,
    '--ant-button-primary-color': colorPrimary,
    '--ant-button-primary-color-hover': colorPrimaryHover,
    '--ant-button-primary-color-active': colorPrimaryActive,
    '--ant-btn-text-color': colorPrimary,
    '--ant-btn-text-color-active': colorPrimaryActive,
  };

  Object.entries(vars).forEach(([key, value]) => {
    document.documentElement.style.setProperty(key, value || '');
  });

  Cookie.set('themeToken', JSON.stringify(theme.token), { domain: getMainDomain() });
};
